import { DeepReadonly } from 'utility-types';
import { InstitutionSummary } from '../Institutions/types';
import { SelectorOption } from '../../web/components/Forms/Selector/types';
import { CourseTileData } from '../../web/components/CourseTile/types';

export type CourseMarketingFilterState = DeepReadonly<{
  featuredInstitutions: Readonly<InstitutionSummary[]>;
  featuredCourses: Readonly<CourseTileData[]>;
  categories: Readonly<string[]>;
  courseTypes: Readonly<SelectorOption[]>;
}>;

export const INITIAL_STATE: CourseMarketingFilterState = {
  featuredInstitutions: [],
  featuredCourses: [],
  categories: [],
  courseTypes: [],
};
